<template>
  <div>
    <div class="card">
      <div class="card-header">
        <strong>General</strong>

        <div class="card-collapse">Collapse</div>
      </div>
      <div class="card-body form-horizontal">
        <div class="row">
          <div class="col-12">
            <div class="card-block">
              <div class="form-group row">
                <label for="title" class="col-md-2">Institution *</label>
                <div class="col-md-10">
                  <input id="title" v-model="entity.title" type="text" placeholder="Enter title" class="form-control">
                </div>
              </div>

              <div class="form-group row">
                <label for="abbreviation" class="col-md-2">Subdomain *</label>
                <div class="col-md-10">
                  <input
                    id="abbreviation"
                    v-model="entity.domain"
                    type="text"
                    placeholder="Enter abbreviation"
                    class="form-control"
                  >
                </div>
              </div>

              <div class="form-group row">
                <label for="localname" class="col-md-2">Institution Local Name</label>
                <div class="col-md-10">
                  <input
                    id="localname"
                    v-model="entity.local_institution"
                    type="text"
                    placeholder="Enter Institution Local Name"
                    class="form-control"
                  >
                </div>
              </div>

              <div class="form-group row">
                <label class="col-md-2">Type</label>
                <div class="col-md-10">
                  <select v-model="entity.type" class="form-control">
                    <option v-for="(value, key) in typeOptions" :key="value" :value="key">
                      {{ value }}
                    </option>
                  </select>
                </div>
              </div>

              <div class="form-group row">
                <label for="library" class="col-md-2">Organisation Library</label>
                <div class="col-md-10">
                  <input
                    id="library"
                    v-model="entity.library"
                    type="text"
                    placeholder="Enter Organisation Library"
                    class="form-control"
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Description -->
    <div class="card">
      <div class="card-header">
        <strong>Description</strong>
      </div>
      <div class="card-body form-horizontal">
        <div class="row">
          <div class="col-12">
            <div class="card-block">
              <div class="form-group row">
                <div class="col-md-12">
                  <ckeditor id="branch-office-description" v-model="entity.description" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Images -->
    <div class="card">
      <div class="card-header">
        <strong>Images</strong>
      </div>
      <div class="card-body form-horizontal">
        <div class="row">
          <div class="col-12">
            <div class="card-block">
              <div class="form-group row">
                <div class="col-md-12">
                  <dropzone
                    v-if="dropzoneOptions"
                    id="files-uploader"
                    ref="dropzone"
                    :options="dropzoneOptions"
                    :destroy-dropzone="false"
                    @vdropzone-file-added="fileUploadedSuccess"
                    @vdropzone-removed-file="fileRemoved"
                  />
                  <div v-else>Dropzone can't work without upload url.</div>
                  <!-- Select Files Button -->
                  <div class="mt-3">
                    <button class="btn btn-success" @click.prevent="$refs.dropzone.dropzone.element.click()">
                      Select Images
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Publishing -->
    <div class="card">
      <div class="card-header">
        <strong>Publication</strong>
      </div>
      <div class="card-body form-horizontal">
        <div class="row">
          <div class="col-12">
            <div class="card-block">
              <div class="form-group row">
                <label for="published" class="col-md-1">Published</label>
                <div class="col-md-10">
                  <input id="published" v-model="entity.published" type="checkbox">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Save Button -->
    <div class="mb-5">
      <button class="btn btn-success" @click="save">
        Save
        <span class="btn-loader" style="display: none;" />
      </button>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import Dropzone from 'vue2-dropzone';
import 'vue2-dropzone/dist/vue2Dropzone.css';

import { uploadStatus } from '@/helpers/constants';
import config from '../../../config';

const { SUCCESS } = uploadStatus;

export default {

  name: 'BranchAbout',

  components: {
    dropzone: Dropzone,
  },

  props: {
    entity: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      typeOptions: {
        main_office: 'Main Office',
        branch_office: 'Branch Office',
        research_center: 'Research Center',
      },
      dropzoneSettings: {
        maxFiles: 50,
        maxFilesize: 100,
      },
      uploadedFiles: [],
      files: [],
      toDeleteFiles: [],

      errorMessage: '',
      errorErrors: '',
    };
  },

  computed: {
    dropzoneOptions() {
      return {
        headers: {
          Authorization: `Bearer ${this.$store.state.user.accessToken.access_token}`,
          Accept: 'application/json',
        },
        method: 'POST',
        paramName: 'media',
        url: `${this.$config.app_api.host}${this.$config.app_api.prefix}branch_office/${this.$route.params.id}/file`,
        maxFilesize: this.dropzoneSettings.maxFilesize,
        maxFiles: this.dropzoneSettings.maxFiles,
        acceptedFiles: 'image/*',
        addRemoveLinks: true,
        autoProcessQueue: false,
        dictRemoveFileConfirmation: 'Do you really want to remove this file?',
      };
    },
    uploadingFiles() {
      const getUploadings = this.$store.getters['uploadManager/getUploadsList'];
      if (!getUploadings) {
        return [];
      }
      return getUploadings(this.$route.params.id, 'branch_office');
    },
  },

  watch: {
    uploadingFiles: {
      handler(val) {
        this.uploadedFiles = val.filter(file => file.status === SUCCESS).map(file => file.file);
        const { dropzone } = this.$refs;
        if (dropzone) {
          this.uploadedFiles.forEach(file => dropzone.removeFile(file));
          this.uploadedFiles.forEach((file) => {
            dropzone.manuallyAddFile(file, '/');
            $('#files-uploader .dz-preview').last().find('.dz-image img').attr('src',
              'static/img/file-thumb.jpg');
          });
        }
      },
      deep: true,
    },
  },

  mounted() {
    this.initCollapse();
    this.getSource();
  },

  destroyed() {
    $(document).off('click', '.card-collapse');
  },

  methods: {
    initCollapse() {
      $(document).on('click', '.card-collapse', function () {
        const $body = $(this).parents('.card').children('.card-body');
        if ($body.hasClass('collapse')) {
          $body.slideDown(function () {
            $(this).removeClass('collapse');
          });
        } else {
          $body.slideUp(function () {
            $(this).addClass('collapse');
          });
        }
      });
    },

    getSource() {
      if (this.entity.images) {
        this.manuallyAddFiles();
      }
    },

    manuallyAddFiles() {
      for (let i = 0; i < this.entity.images.length; i += 1) {
        const file = {
          file: {
            name: this.entity.images[i].file_name,
            size: this.entity.images[i].size,
          },
          url: this.entity.images[i].public_url,
        };
        this.$refs.dropzone.manuallyAddFile(file.file, file.url);
        if (!this.entity.images[i].mime_type.match(/image.*/)) {
          $('#files-uploader .dz-preview').last().find('.dz-image img').attr('src', 'static/img/file-thumb.jpg');
        }
      }
    },
    fileUploadedSuccess(file) {
      this.files.push(file);
    },
    fileRemoved(file) {
      const fileIndex = _.findIndex(this.entity.images, item => item.file_name === file.name && item.size === file
        .size);
      if (fileIndex === -1) return;
      const fileId = this.entity.images[fileIndex].id;
      this.toDeleteFiles.push(fileId);
    },

    saveRequest() {
      const postFormData = new FormData();

      postFormData.append('title', this.entity.title);
      postFormData.append('domain', this.entity.domain);
      postFormData.append('type', this.entity.type);

      postFormData.append('local_institution', this.entity.local_institution ? this.entity.local_institution : '');
      postFormData.append('library', this.entity.library ? this.entity.library : '');
      if (this.entity.description) {
        postFormData.append('description', this.entity.description);
      }
      postFormData.append('published', this.entity.published || false);
      postFormData.append('address', JSON.stringify(this.entity.address.address));
      postFormData.append('mail_address', JSON.stringify(this.entity.address.mail_address));
      postFormData.append('alt_address', JSON.stringify(this.entity.address.alt_address));
      postFormData.append('contacts', JSON.stringify(this.entity.contacts));
      postFormData.append('location', JSON.stringify(this.entity.location));
      postFormData.append('sections', JSON.stringify(this.entity.sections));
      postFormData.append('boxes', JSON.stringify(this.entity.boxes));

      return this.$apiHttp.post(`${this.$config.app_api.prefix}branch-offices/${this.$route.params.id}`,
        postFormData);
    },
    save() {
      $('.saving-alerts .alert').hide();
      $('.btn-success .btn-loader').show();
      const files = this.files.filter(file => !file.manuallyAdded);
      const {
        prefix,
        host,
      } = this.$config.app_api;
      const {
        acceptedFiles,
      } = this.dropzoneOptions;
      const vm = this;
      const token = JSON.parse(localStorage.getItem(config.tokenStorage.name));

      if (this.toDeleteFiles.length) {
        for (let i = 0; i < this.toDeleteFiles.length; i += 1) {
          this.$apiHttp
            .delete(
              // eslint-disable-next-line max-len
              `${this.$config.app_api.host}${this.$config.app_api.prefix}branch-offices/${this.$route.params.id}/images/${this.toDeleteFiles[i]}`,
            )
            // eslint-disable-next-line no-loop-func
            .then(() => {
              this.entity.files.splice(i, 1);
              this.files = this.files.filter(item => file !== item);
            })
            .catch((error) => {
              console.error('error in delete file in site page request - ', error);
            });
        }
      }

      this.saveRequest().then(() => {
        $('.btn-success .btn-loader').hide();
        this.$store.commit('notifications/setSuccessNotification', 'Success!');
        $('.saving-alerts .alert-success').show();
        if (files && files.length > 0) {
          this.$store.dispatch('uploadManager/startUpload', {
            apiHost: host,
            apiPrefix: prefix,
            entityId: this.$route.params.id,
            files: [...files],
            token,
            acceptedFiles,
            contentType: 'branch_office',
          });
          vm.files = [];
        }
      }).catch((error) => {
        $('.btn-success .btn-loader').hide();
        this.$store.commit('notifications/setDangerNotification', 'Error!');
        console.error('Error in update branch office query', error);
      });
    },

  },
};

</script>



// WEBPACK FOOTER //
// About.vue?d7d34218